import { __assign, __read, __rest, __spreadArray } from "tslib";
import { useState, useRef } from "react";
import { noop } from "./noop";
export function useDefault(value, defaultValue, onChange) {
    var isControlledRef = useRef(false);
    var _a = __read(useState(defaultValue), 2), internalValue = _a[0], setInternalValue = _a[1];
    // 受控模式
    if (isControlledRef.current || typeof value !== "undefined") {
        isControlledRef.current = true;
        return [value, onChange || noop];
    }
    // 非受控模式
    return [
        internalValue,
        function (newValue) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            setInternalValue(newValue);
            if (typeof onChange === "function") {
                onChange.apply(void 0, __spreadArray([newValue], __read(args)));
            }
        },
    ];
}
/**
 * 可直接接管 props 中 `value`，`defaultValue` 及 `onChange` 受控属性
 */
export function useDefaultValue(props, defaultDefaultValue) {
    var defaultValue = props.defaultValue, value = props.value, _a = props.onChange, onChange = _a === void 0 ? noop : _a, restProps = __rest(props, ["defaultValue", "value", "onChange"]);
    var _b = __read(useDefault(value, typeof defaultValue === "undefined" ? defaultDefaultValue : defaultValue, onChange), 2), finalValue = _b[0], finalOnChange = _b[1];
    return __assign({ value: finalValue, onChange: finalOnChange }, restProps);
}
//# sourceMappingURL=use-default.js.map